import getExtensibilityState from '../store/getExtensibilityState';
import TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';
import TaskPaneType from '../store/schema/TaskPaneType';
import { getConverseTaskPaneType, getTaskPaneRunningInstance } from '../utils/taskPaneUtils';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('toggleTaskPaneType', function toggleTaskPaneType(type: TaskPaneType) {
    const taskPane: TaskPaneRunningInstance = getTaskPaneRunningInstance(type);
    if (!taskPane) {
        return;
    }

    const { taskPanes } = getExtensibilityState();

    taskPanes.delete(type);
    taskPanes.set(getConverseTaskPaneType(type), taskPane);
});
